import React from 'react';
import config from 'src/config';

class Component extends React.Component {
  saveLink = (e) => {
    e.preventDefault();
    let {
      link_id,
      link_name,
      link,
      color_bb,
      file,
      image,
      suboffer,
      orderid,
      exclusive_list_id,
      wids,
      redirect_wids,
      redirect_list_id,
      redirect_to,
      imagesCount,
      editable,
      hidden,
      inputRef,
      tab,
    } = this.props.link;
    let type = this.props.type;

    if (!link || !link_name) return;
    let newLink = {
      link_id: link_id || 0,
      type: type,
      suboffer: suboffer,
      link_name: link_name || '',
      link: link,
      color_bb: color_bb || '',
      hidden: hidden == 1 ? 1 : 0,
      wids: wids || '',
      exclusive_list_id: exclusive_list_id || 0,
      redirect_wids: redirect_wids || '',
      redirect_list_id: redirect_list_id || 0,
      redirect_to: redirect_to || 0,
      images: imagesCount || 0,
      editable: editable == 1 ? 1 : 0,
      file: file,
      image: image,
      order: parseInt(orderid || 0),
    };
    console.log('addLink', newLink);
    this.props
      .api('links/save', newLink, true, (e, progress) => {}, true)
      .then((res) => {
        this.props.onSaveLink(res, newLink, type);
      });
  };

  removeLink = (e) => {
    e.preventDefault();
    if (!confirm('Are you sure?')) return;
    let { link_id, image } = this.props.link;
    this.props
      .api('links/remove', {
        link_id,
        image: image || 0,
      })
      .then((res) => {
        console.log('links/remove res:', res);
        this.props.onRemoveLink(res);
      });
  };

  render() {
    let {
      link_id,
      link_name,
      link,
      color_bb,
      file,
      image,
      suboffer,
      orderid,
      wids,
      exclusive_list_id,
      redirect_wids,
      redirect_list_id,
      redirect_to,
      imagesCount,
      editable,
      hidden,
      inputRef,
    } = this.props.link;
    let { handleInputChange, saveLink, removeLink, closeEditModal } = this.props;
    let widLists = this.props.listApiState.data && this.props.listApiState.data.items;
    var curRedirectList = {};
    var curExclusiveList = {};
    widLists.map((list) => {
      if (list.id == redirect_list_id) curRedirectList = list;
      if (list.id == exclusive_list_id) curExclusiveList = list;
    });

    return (
      <div>
        <form class="modal fade black-overlay show d-block" onSubmit={this.saveLink}>
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{link_id ? 'Edit link ' + link_id : 'Add link'}</h5>
              </div>
              <div class="modal-body">
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Name</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Name"
                      name="link_name"
                      value={link_name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Link</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Link"
                      name="link"
                      value={link}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Default color</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="color"
                      name="color_bb"
                      value={color_bb}
                      onChange={handleInputChange}
                      minLength="6"
                      maxLength="6"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Upload</label>
                  <div class="col-sm-10">
                    <input
                      type="file"
                      class="form-control"
                      placeholder="Image"
                      name="file"
                      onChange={handleInputChange}
                      ref={inputRef}
                    />
                  </div>
                </div>
                {!file && (
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Picname</label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="image name"
                        name="image"
                        value={image || ''}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                )}
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Suboffer</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Suboffer"
                      name="suboffer"
                      value={suboffer}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Order</label>
                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="order"
                      name="orderid"
                      value={orderid}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Exclusive list</label>
                  <div class="col-sm-10">
                    <select
                      name="exclusive_list_id"
                      onChange={handleInputChange}
                      class="form-control"
                      value={exclusive_list_id}
                    >
                      <option value="0"></option>
                      {widLists.map((list) => (
                        <option key={list.id} value={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Exclusive wids</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="wid1,wid2,..."
                      name="wids"
                      value={exclusive_list_id > 0 ? curExclusiveList.wids : wids}
                      onChange={handleInputChange}
                      disabled={exclusive_list_id > 0}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Redirect list</label>
                  <div class="col-sm-10">
                    <select
                      name="redirect_list_id"
                      onChange={handleInputChange}
                      class="form-control"
                      value={redirect_list_id}
                    >
                      <option value="0"></option>
                      {widLists.map((list) => (
                        <option key={list.id} value={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Redirect wids</label>
                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="wid1,wid2,..."
                      name="redirect_wids"
                      value={redirect_list_id > 0 ? curRedirectList.wids : redirect_wids}
                      onChange={handleInputChange}
                      disabled={redirect_list_id > 0}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Redirect link id</label>
                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="link id (number)"
                      name="redirect_to"
                      value={redirect_to}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Images</label>
                  <div class="col-sm-10">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="number of images"
                      name="imagesCount"
                      value={imagesCount}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-2">Editable</div>
                  <div class="col-sm-10">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="editable"
                        checked={editable == 1}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-2">Hidden</div>
                  <div class="col-sm-10">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="hidden"
                        checked={hidden == 1}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                {link_id ? (
                  <button type="button" class="btn danger link-remove" onClick={this.removeLink}>
                    Remove
                  </button>
                ) : (
                  ''
                )}
                <button type="button" class="btn warning" onClick={closeEditModal}>
                  Cancel
                </button>
                <button type="submit" class="btn primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function(state) {
    return {
      listApiState: state.api['affLists_load'] || state.api.initial,
      apiState: state.api['links_save'] || state.api.initial,
      removeApiState: state.api['links_remove'] || state.api.initial,
      state: state.state['links_save'] || state.state.initial,
      user: state.session.user,
    };
  },
  {
    api,
    setState: setState('links_save'),
  }
)(Component);
